import { Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import TextCounter from './pages/TextCounter';
import JsonEditor from './pages/JsonEditor';
import CsvEditor from './pages/CsvEditor';
import usePageView from './helpers/usePageView';
function App() {
  const [cookieConsent, setCookieConsent] = useState('');

  // ページビューを計測
  const trackingId = "G-6C60QL7MSB";
  usePageView(trackingId);

  // クッキーの同意状態を取得
  useEffect(() => {
    const storedConsent = localStorage.getItem("cookieConsent");
    if (storedConsent) {
      setCookieConsent(storedConsent);
    }
  }, []);

  return (
    <div>
      <Routes>
        <Route path="/" element={<TextCounter cookieConsent={cookieConsent} setCookieConsent={setCookieConsent} />} />
        <Route path="/json-editor" element={<JsonEditor cookieConsent={cookieConsent} setCookieConsent={setCookieConsent} />} />
        <Route path="/csv-editor" element={<CsvEditor cookieConsent={cookieConsent} setCookieConsent={setCookieConsent} />} />
      </Routes>
    </div>
  )
}

export default App;
